<template>
  <Page>
    <section class="tplsetting-container">
      <Announce style="margin-top: 8px;" />
      <Breadcrumb 
        title="模版配置" 
        :extraTabs="extraTabList" 
        @extra="extraTabHandle"
      />
      
      <HPL :data="curExtraTab" />
      <!-- <HPL v-if="curExtraTab?.field == 'hpl'" /> -->
    </section>
  </Page>
</template>

<script setup>
  import {onMounted, ref, watch} from 'vue';
  import * as Request from '@/assets/request';
  import Page from '@/components/page';
  import Breadcrumb from '@/components/breadcrumb';
  import HPL from './components/hpl';
  import Announce from '@/components/announce';

  /**
   * 初始化
   */
  const extraTabList = ref([])
  const curExtraTab = ref(null)
  const getTabList = async () => {
    const result = await Request.post({
      url: '/22001/facade/commons/params/template/getAllApp'
    });
    if(result?.code != 200) return;

    if(result?.data?.length > 0) {
      const _extraTabList = []
      result.data.map(item => {
        _extraTabList.push({ ...item?.group, label: item?.group?.name });
      })
      extraTabList.value = _extraTabList;
      
      extraTabHandle(_extraTabList[0])
    }
  }
  onMounted(() => {
    getTabList()
  })

  // 切换
  const extraTabHandle = item => {
    curExtraTab.value = item;
    extraTabList.value.map(_item => {
      _item.active = false;
      if(_item.id == item.id) {
        _item.active = true;
      }
      return _item;
    });
  }
</script>

<style scoped lang="less">
  @import "./index.less";
</style>